import {
  KeyMultipleRegular,
  PeopleRegular,
  ShieldKeyholeRegular,
  ShieldPersonRegular,
} from '@fluentui/react-icons';
import type { ModuleDef } from '#src/app/navigation/module';

export const adminModule: ModuleDef = {
  path: 'admin',
  title: 'Administração',
  icon: ShieldPersonRegular,
  placement: 'footer',
  pages: [
    {
      path: 'usuarios',
      title: 'Usuários',
      description:
        'Quem tem acesso, com quais perfis, e o app no Teams de cada um.',
      icon: PeopleRegular,
      permission: 'Users.Read',
      load: () =>
        import('#src/modules/admin/UsersPage').then((m) => m.UsersPage),
    },
    {
      path: 'perfis',
      title: 'Perfis',
      description: 'O que cada perfil permite fazer no app.',
      icon: ShieldKeyholeRegular,
      permission: 'Roles.Read',
      load: () =>
        import('#src/modules/admin/RolesPage').then((m) => m.RolesPage),
    },
    {
      path: 'permissoes',
      title: 'Permissões',
      description: 'Todas as permissões do app: o que cada uma libera e exige.',
      icon: KeyMultipleRegular,
      permission: 'Permissions.Read',
      load: () =>
        import('#src/modules/admin/PermissionsPage').then(
          (m) => m.PermissionsPage,
        ),
    },
  ],
  routes: [
    {
      path: 'usuarios/:id',
      title: 'Usuário',
      permission: 'Users.Read',
      load: () => import('#src/modules/admin/UserPage').then((m) => m.UserPage),
    },
    {
      path: 'perfis/:code',
      title: 'Perfil',
      permission: 'Roles.Read',
      load: () => import('#src/modules/admin/RolePage').then((m) => m.RolePage),
    },
    {
      path: 'permissoes/:key',
      title: 'Permissão',
      permission: 'Permissions.Read',
      load: () =>
        import('#src/modules/admin/PermissionPage').then(
          (m) => m.PermissionPage,
        ),
    },
  ],
};
